<template>
  <div  :class="styleClasses">
    <input id="tel-input" :disabled="disabled" ref="phone" :style="customStyle" v-model="mobile" @blur="update"/>
  </div>
</template>

<script>
/* eslint-disable */
import 'intl-tel-input/build/css/intlTelInput.css'
import intlTelInput from 'intl-tel-input'
import localizedCountries from "@/components/common/tel-input/localizedCountries";
import utils from './utils'
export default {
  name: 'CommonTelInput',
  props: {
    value: {
      type: Object,
      default () {
        return {
          mobile: '',
          regionCode:"cn"
        }
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    styleClasses: {
      type: Object,
      default () {
        return null
      }
    },
    customStyle:{}
  },
  model: {
    prop: 'value',
    event: 'changeValue'
  },
  data(){
    return{
      iti:null,
      regionCode:this.value.regionCode || "cn",
      mobile:this.value.mobile
    }
  },
  mounted () {
    let map = new Map();
    let countryData = window.intlTelInputGlobals.getCountryData()
    countryData.forEach(item=>{
      map.set(item.regionCode,item.dialCode)
    })
    const input = this.$refs.phone
    this.iti = intlTelInput(input, {
      // customContainer: "container",
      preferredCountries: ["cn"],
      separateDialCode: true,
      formatOnDisplay:false,
      localizedCountries,
      customPlaceholder: function(selectedCountryPlaceholder, selectedCountryData) {
        return selectedCountryPlaceholder.replace(/\d/ig,'x');
      },
      // any initialisation options go here
    })
    if(this.value.regionCode){
      this.iti.setCountry(this.value.regionCode)
    }
    if(this.value.mobile){
      this.iti.setNumber(this.value.mobile)
    }
    input.addEventListener("countrychange", this.onCountryChange);
    this.iti.promise.then(this.updateValidStatus)
  },
  methods:{
    update(){
      let selectedCountryData = this.iti.getSelectedCountryData();
      this.regionCode = selectedCountryData.iso2
      this.$emit('changeValue',{regionCode:this.regionCode,mobileDial:selectedCountryData.dialCode,mobile:this.mobile ? this.mobile.replace(/\s*/g,""): this.mobile})
      this.updateValidStatus()
    },
    updateValidStatus(){
      let isValid =this.iti.isValidNumber();
      // 加入192号段校验
      const res = /^[1][9][2][0-9]{8}$/;
      if(!isValid && this.regionCode === 'cn' && res.test(this.mobile)){
        isValid = true
      }
      this.$emit('validChange',isValid)
    },
    onCountryChange () {
      this.update()
    }
  }
}
</script>

<style lang="less" >
#tel-input::placeholder{
  color: #c5c8ce;
}
.iti__flag,.iti__flag-box {
  display: none;
}
</style>

